<template>
  <div>

    <v-navigation-drawer
      :value="showDrawer"
      app
      width="350"
      @input="showDrawer = $event"
    >
      <v-toolbar class="elevation-1">
        <v-btn
          @click="$router.go(-1)"
          icon
          class="hidden-xs-only"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-spacer></v-spacer>
      </v-toolbar>

      <div class="course-info text-center py-5 px-5">
        <div class="course-title">{{selectedCourse.title}}</div>

        <div class="course-progress mt-3">
          <v-progress-linear
            color="primary"
            rounded
            :value="curseProgress"
            height="10"
          >
          </v-progress-linear>

          <div class="text-progress mt-2">
            <strong>{{curseProgress}}%</strong> {{$t('settings.courses.complete')}}
          </div>
        </div>
      </div>

      <v-list
        nav
        class="units"
      >
        <v-list-item-group
          v-model="selectedUnitIndex"
          mandatory
          active-class="primary--text text--accent-4"
        >
          <v-list-item
            v-for="(unit, index) in selectedCourse.units"
            :key='unit._id'
            :disabled="!unit.videoUrl || (isLocked && !unit.isFree)"
            :class="{'item-disabled': !unit.videoUrl}"
          >
            <v-list-item-icon class="unit-progress-wrapper mr-3 ml-2">
              <div class="unit-progress">
                <div v-if="(unit.isCompleted || unit.cardsToStudy === 0) && unit.videoViewedDate" class="full d-flex align-center justify-center"><iconCheck/></div>
                <div v-if="!unit.isCompleted && selectedUnitIndex === index" class="half"></div>
              </div>
            </v-list-item-icon>
            <div class="divider"></div>
            <v-list-item-icon class="unit-icon ml-2 mr-2">
              <videoIcon v-if="unit.videoUrl" />
              <iconLockTime v-else />
            </v-list-item-icon>
            <v-list-item-title>{{unit.title}}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <router-view :unit="selectedUnit" :isLocked="isLocked" @complete="complete" @next="nextUnit"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
// import toastr from '@/plugins/toastr';

import videoIcon from '@/static/img/video-icon.svg';
import iconCheck from '@/static/img/icon-check.svg';
import iconLockTime from '@/static/img/icon-lock-time.svg';

export default {
  name: 'Courses',

  inject: ['headerSettings'],

  components: {
    videoIcon,
    iconCheck,
    iconLockTime,
  },

  data () {
    return {
      magicLink: '',
      selectedUnitIndex: 0,
      isLocked: false,
    };
  },

  computed: {
    ...mapGetters({
      courses: 'user/courses',
    }),

    showDrawer: {
      get () {
        return this.headerSettings.showDrawer;
      },

      set (v) {
        this.headerSettings.showDrawer = v;
      },
    },

    selectedCourse () {
      return this.courses[0] || { units: [] };
    },

    curseProgress () {
      if (!this.selectedCourse._id) {
        return 0;
      }

      const units = this.selectedCourse.units;
      const completedUnits = units.filter(unit => unit.isCompleted);

      return Math.floor(completedUnits.length * 100 / units.length);
    },

    selectedUnit () {
      return this.selectedCourse.units[this.selectedUnitIndex] || {};
    },
  },

  watch: {
    selectedUnit () {
      window.$crisp && window.$crisp.push(['set', 'session:data', [[['currentUnit', this.selectedUnit.title]]]]);
    },
  },

  created () {
    this.getLoginLink();

    if (this.courses[0]) {
      this.selectedUnitIndex = this.courses[0].units.findIndex(unit => !unit.isCompleted);
      this.$route.name === 'courses' && this.$router.replace({ name: 'course', params: { id: this.courses[0]._id } });
    }
  },

  methods: {
    complete (done) {
      axios({
        method: 'post',
        url: `users/me/learningVideoCourse/${this.selectedCourse._id}/complete/${this.selectedUnit._id}`,
      }).then(result => {
        done();
      });
    },

    nextUnit (unitId) {
      this.selectedUnitIndex++;
    },

    getLoginLink () {
      axios({
        method: 'post',
        url: 'users/me/login-link',
        data: { redirectTo: 'settings' },
      }).then(result => {
        this.magicLink = result.data.link;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.unit-progress-wrapper {
  .unit-progress {
    width: 20px;
    height: 20px;
    border-radius: 10px;
    border: 2px solid #fa507b;
    overflow: hidden;

    .half {
      height: 20px;
      width: 8px;
      background: #fa507b;
    }
    .full {
      height: 16px;
      width: 16px;
      background: #fa507b;

      svg {
        width: 10px;
        height: 10px;
        color: white;
      }
    }
  }
}

.divider {
  height: 36px;
  width: 2px;
  background: white;
  z-index: 1;
}

.course-info {
  background: #fafafa;
}

.course-title {
  font-size: 1.125rem;
  line-height: 1.688rem;
  font-weight: 600;
}

.text-progress {
  font-size: 18px;
}

.unit-icon {
  svg {
    width: 24px;
    height: 22px;
  }
}

.item-disabled {
  cursor: progress;
}

.units {
  height: calc(100vh - 222px);
  overflow: auto;
}
</style>
